export default "__VITE_ASSET__Cc7Ghd1m__"